import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import '../../App.css';
import { StyleConstants, Styles } from '../../Styles';
import { jsonToTable } from '../../utils/StringUtils';

const RawData2Tab = (props) => {
    const { packet } = props;
    
    return (
        <>
            <Stack direction='row' spacing={1}>
                {(packet.data2 !== null) && (packet.data2.data !== null) && (
                    <Box key="data">
                        {jsonToTable(packet.data2.data)}
                    </Box>
                )}

                {(packet.data2 !== null) && (packet.data2.updatedTime !== null) && (
                    <Box key="updatedTime">
                        <TableContainer component={Paper}>
                            <Table size='small' sx={{ border: '3px solid ' + StyleConstants.borderColor }}>
                                <TableBody>
                                    <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                        <TableCell>
                                            <Typography sx={{ whiteSpace: 'nowrap', width: '230px', height:'25px', margin: '0px', padding: '0px' }}>
                                                updatedTime
                                            </Typography>
                                        </TableCell>
                                        <TableCell sx={{ ...Styles.carBorderCellRight }}>
                                            <Typography sx={{ whiteSpace: 'nowrap', width: '230px', height:'25px', margin: '0px', padding: '0px' }}>
                                                {packet.data2.updatedTime}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                )}
            </Stack>
        </>
    );
};

export default RawData2Tab;